const SEPTEMBER_2024 = new Date('2024-09-01').getTime();

export function withVAT(value: number, startTime: Date = new Date()): number {
  if (startTime.getTime() >= SEPTEMBER_2024) {
    return value * 1.255;
  } else {
    return value * 1.24;
  }
}